import { render, staticRenderFns } from "./AsideMovilComponent.vue?vue&type=template&id=c5c5c852&"
import script from "./AsideMovilComponent.vue?vue&type=script&lang=js&"
export * from "./AsideMovilComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports